import {
  ButtonsContainer,
  LinkLabel,
  Root,
  SearchIconImg,
  SearchInput,
  SearchInputWrapper,
  SubTitle,
  Title,
} from './styles';

import searchIcon from '@assets/icons/search-icon.svg';
import Underline from '@components/Underline';
import Button from '@components/Button';
import { Column } from '@components/LinearLayout';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';
import PortfolioOverviewFooter from '@composites/Footers/PortfolioOverviewFooter';
import CompanyNav from '@composites/Headers/CompanyNav';

const ErrorPage404 = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <CompanyNav />
      <Root>
        <Column $gap="3.75rem">
          <Column $gap="2.5rem">
            <Title $color={'#009FE3'}>{t('event-not-found-title')}</Title>
            <SubTitle>{t('event-not-found-subtitle')}</SubTitle>
          </Column>
          <Underline width="163px" color={'#009FE3'} justify="flex-start" />

          <SearchInputWrapper>
            <SearchIconImg src={searchIcon} alt="Search" />
            <SearchInput
              type="text"
              placeholder={t('event-not-found-search-placeholder')}
            />
          </SearchInputWrapper>
        </Column>
        <ButtonsContainer>
          <Column $gap="2.5rem" $alignItems={'flex-start'}>
            <LinkLabel>{t('event-not-found-home-question')}</LinkLabel>
            <Button
              title={t('event-not-found-home-button')}
              backgroundColor={'#009FE3'}
              border={`1px solid #009FE3`}
              padding="1.1rem 5rem"
              borderRadius="1.2rem"
              fontSize="2rem"
              onClick={() => {
                navigate('/');
              }}
            />
          </Column>

          <Column $gap="2.5rem" $alignItems={'flex-start'}>
            <LinkLabel>{t('event-not-found-contact-question')}</LinkLabel>
            <Button
              title={t('event-not-found-contact-button')}
              backgroundColor={theme.color.white}
              hoverTextColor={'#009FE3'}
              padding="1.1rem 5rem"
              borderRadius="1.2rem"
              border={`1px solid ${'#009FE3'}`}
              textColor={'#009FE3'}
              fontSize="2rem"
              onClick={() => {
                navigate(`${t('mappable-company-routes.contact-url')}`);
              }}
            />
          </Column>
        </ButtonsContainer>
      </Root>
      <PortfolioOverviewFooter />
    </>
  );
};

export default ErrorPage404;
